import { useEffect, useRef } from "react";
import { useSettings } from "@/hooks/useSettings";

export const useAutoRefresh = (fn, deps = []) => {
  const ref = useRef(fn);
  ref.current = fn;
  const { settings } = useSettings();
  const interval = Math.max(10, Number(settings?.refresh_seconds) || 30) * 1000;
  useEffect(() => {
    const run = () => { if (document.visibilityState === "visible") ref.current(); };
    const t = setInterval(run, interval);
    window.addEventListener("focus", run);
    window.addEventListener("app-refresh", run);
    document.addEventListener("visibilitychange", run);
    return () => { clearInterval(t); window.removeEventListener("focus", run); window.removeEventListener("app-refresh", run); document.removeEventListener("visibilitychange", run); };
  }, [interval, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
};
